const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		adFlag: true,
		mid: null,
		// 试题类型(1章节练习, 2历年真题, 3模拟考试, 4我的错题)
		type: null,
		// 科目
		courseList: [],
		cid: 0,
		allCourseFlag: true,
		getURL: '',
		page: 1,
		rows: 10,
		totalPage: 1,
		testList: [],
		wrongList: [],
		done: true
	},
	methods: {
		// 获取参数
		getParams() {
			this.mid = this.getQueryString('mid') - 0 || 11;
			this.type = this.getQueryString('type') - 0 || 2;
			this.cid = this.getQueryString('cid') - 0 || 0;
			this.page = this.getQueryString('page') - 0 || 1;
			// 1 章节练习, 2 历年真题, 3 模拟测试
			switch (this.type) {
				case 1:
					this.getURL = xcxBase + 'getChaptersAndSections';
					break;
				case 2:
					this.getURL = xcxBase + 'getAllReal';
					break;
				case 3:
					this.getURL = xcxBase + 'getAllSimul';
					break;
				case 4:
					this.getWrongList();
					break;
				default:
					break;
			}
		},
		// 切换试题类型
		changeType(type) {
			if (type == 4) {
				location.href = base + 'pages/test/list.html?mid=' + this.mid + '&type=4&cid=0';
			} else {
				location.href = base + 'pages/test/list.html?mid=' + this.mid + '&type=' + type + '&cid=' + this.cid + '&page=1';
			}
		},
		// 获取科目
		getCourseList(callback) {
			let mid = this.mid;
			if (this.mid == 71) {
				mid = 11;
			}
			if (this.mid == 91) {
				mid = 13;
			}
			axios.post(baseURL + 'getCourseByMid?mid=' + mid)
				.then(res => {
					if (res.code == 200) {
						if (this.cid == 0) {
							this.cid = res.list[0].id;
						}
						res.list.forEach(item => {
							item.isActive = false;
							if (item.id == this.cid) {
								this.allCourseFlag = false;
								item.isActive = true;
							}
						});
						this.courseList = res.list;
						if (typeof callback == 'function') {
							callback();
						}
					}
				})
				.catch(err => console.log(err));
		},
		// 不限科目
		allCourse() {
			location.href = base + 'pages/test/list.html?mid=' + this.mid + '&type=' + this.type + '&cid=0&page=1';
		},
		// 科目筛选
		changeCourse(course) {
			location.href = base + 'pages/test/list.html?mid=' + this.mid + '&type=' + this.type + '&cid=' + course.id + '&page=1';
		},
		// 获取列表
		getList() {
			let mid = this.mid;
			if (this.mid == 71) {
				mid = 11;
			}
			if (this.mid == 91) {
				mid = 13;
			}
			axios.post(this.getURL
				+ '?ly=2&page=' + this.page
				+ '&rows=' + this.rows
				+ '&mid=' + mid
				+ '&cid=' + this.cid)
				.then(res => {
					if (res.code == 200) {
						// 章节练习
						if (this.type == 1) {
							res.list.forEach(item => {
								item.isActive = false;
								item.subList = [];
							});
						}
						this.testList = res.list;
						this.totalPage = Math.ceil(res.total / this.rows);
					}
				})
				.catch(err => console.log(err));
		},
		// 获取 节
		getSectionsList(chapter) {
			chapter.isActive = !chapter.isActive;
			if (chapter.hasSubList) {
				return;
			}
			let mid = this.mid;
			if (this.mid == 71) {
				mid = 11;
			}
			if (this.mid == 91) {
				mid = 13;
			}
			axios.post(xcxBase + 'getSections?ly=2&cid=' + chapter.id + '&mid=' + mid)
				.then(res => {
					if (res.code == 200) {
						chapter.subList = res.list;
						chapter.hasSubList = true;
					}
				})
				.catch(err => console.log(err));
		},
		// 获取错题
		getWrongList() {
			let mid = this.mid;
			if (this.mid == 71) {
				mid = 11;
			}
			if (this.mid == 91) {
				mid = 13;
			}
			axios.post(xcxBase + 'getMywrongMidg?ly=2&mid=' + mid)
				.then(res => {
					if (res.code == 200) {
						this.wrongList = res.list;
					}
					if (res.code == -3) {
						this.goLogin();
					}
				})
				.catch(err => console.log(err));
		},
		// 跳转详情(sc: 章/c节)
		goDetail(id, mode, keep, title, sc) {
			if (sc == 'c') {
				location.href = base + 'pages/test/detail.html?type=' + this.type + '&mode=' + mode + '&keep=' + keep + '&cid=' + id + '&title=' + title + '&mid=' + this.mid + '&href=' + encodeURIComponent(location.href);
			} else {
				location.href = base + 'pages/test/detail.html?type=' + this.type + '&mode=' + mode + '&keep=' + keep + '&sid=' + id + '&title=' + title + '&mid=' + this.mid + '&href=' + encodeURIComponent(location.href);
			}
		},
		// 跳转模式
		goMode(id, keep, yznums, yzksnums) {
			location.href = base + 'pages/test/mode.html?type=' + this.type + '&sid=' + id + '&keep=' + keep + '&yznums=' + yznums + '&yzksnums=' + yzksnums + '&mid=' + this.mid + '&href=' + encodeURIComponent(location.href);
		},
		// 错题
		goWrong(id, mode, title) {
			location.href = base + 'pages/test/detail.html?type=4&mode=' + mode + '&cid=' + id + '&title=' + title + '&mid=' + this.mid + '&href=' + encodeURIComponent(location.href);
		},
		//分页
		turnPage(page) {
			location.href = base + 'pages/test/list.html?mid=' + this.mid + '&type=' + this.type + '&cid=' + this.cid + '&page=' + page;
		}
	},
	mounted: function () {
		this.getParams();
		this.getCourseList(() => {
			if (this.type != 4) {
				this.getList();
			}
		});
	}
});